import { render, staticRenderFns } from "./DocumentSelect.vue?vue&type=template&id=080fb356&scoped=true"
import script from "./DocumentSelect.vue?vue&type=script&lang=js"
export * from "./DocumentSelect.vue?vue&type=script&lang=js"
import style0 from "./DocumentSelect.vue?vue&type=style&index=0&id=080fb356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080fb356",
  null
  
)

export default component.exports